import { render } from "./CreateUserPresence.vue?vue&type=template&id=48acea64"
import script from "./CreateUserPresence.vue?vue&type=script&lang=js"
export * from "./CreateUserPresence.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__